
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal",
      function () {
        return require("private-next-pages/personal.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal"])
      });
    }
  